export default {
  readImgAsURL(data) {
    return new Promise((resolve, reject) => {
      const file = new FileReader()
      file.onload = () => {
        resolve(file.result)
      }
      file.onerror = () => {
        reject(file.result)
      }
      file.readAsDataURL(data)
    })
  },
}

export const readFileAsBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    // 监听读取完成事件
    reader.onload = e => {
      resolve(e.target.result)
    }
    reader.onerror = e => {
      reject(e.target.error.message)
    }
    // 开始读取文件，结果会以DataURL形式返回
    reader.readAsDataURL(file)
  })
}
